import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function Cloud() {
  const [otas, setOtas] = useState([]);
  const [Search, setSearch] = useState("");
  const [loading2, setloading2] = useState(true);
  const [filteredData, setFilteredData] = useState([]);

  //////////////get ota list///////////////

  useEffect(() => {
    const fetchOtas = async () => {
      try {
        const item = localStorage.getItem("otaHistory");
        if (item !== undefined) {
          setOtas(JSON.parse(item));
        }
        fetch(`https://db2sg.com/HamitaherApi/history.php`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `HTTP error! Status: ${response?.status} ${response?.statusText}`
              );
            }

            return response.json();
          })
          .then((result) => {
            console.log(result);
            setOtas(result);
            setFilteredData(result);
            setloading2(false);
            localStorage.setItem("otaHistory", JSON.stringify(result));
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.error("Error fetching OTAs:", error);
      }
    };

    fetchOtas();
  }, []);
  useEffect(() => {
    const lowercasedSearch = Search.toLowerCase();

    if (lowercasedSearch !== "") {
      const filtered = otas?.filter((item) => {
        return (item?.users)?.some((user) => {
          // Check if any field contains the search term
          return (
            user.email?.toLowerCase().includes(lowercasedSearch) ||
            user.phoneNumber?.toLowerCase().includes(lowercasedSearch) ||
            user.orgName?.toLowerCase().includes(lowercasedSearch) ||
            user.name?.toLowerCase().includes(lowercasedSearch) ||
            item?.versionNo?.toLowerCase().includes(lowercasedSearch)
          );
        });
      });

      setFilteredData(filtered);
    } else {
      setFilteredData(otas);
    }
  }, [Search, otas]);
  const getDate = ({ _seconds, _nanoseconds }) => {
    const timestamp = _seconds * 1000 + _nanoseconds / 1000000;
    const date = new Date(timestamp);
    return date;
  };

  const formatTimestamp = ({ _seconds, _nanoseconds }) => {
    const timestamp = _seconds * 1000 + _nanoseconds / 1000000;
    const date = new Date(timestamp);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    });
  };
  const { t } = useTranslation();
  return (
    <>
      <div className="container-fluid mt-1 mb-4">
        <div className="row align-items-center justify-content-between">
          <div className="col-auto">
            <h5 className="mt-2" style={{ color: "#Ae8625" }}>
              {t("OTA List")}
            </h5>
          </div>
          <div className="col-auto">
            <div className="search-container d-flex align-items-center">
              <input
                value={Search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                style={{
                  background:
                    "linear-gradient(45deg, #Ae8625, #f7ef8a, #d2ac47, #edc967)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
                type="text"
                className="search-input"
                placeholder="Search..."
              />
              {/* <img
                      src="assets/search.png"
                      className="search-icon"
                      alt="Search"
                    /> */}
            </div>
          </div>
        </div>
      </div>
      {loading2 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
          }}
        >
          <div className="spinner"></div>
        </div>
      ) : (
        <div style={{ maxHeight: "80vh", overflowY: "auto" }}>

        <table className="table table-borderless table-responsive">
          <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>
            <tr style={{ fontSize: "95%" }}>
              <th style={{ fontSize: "100%" }} scope="col">
                {t("Version")}
              </th>
              <th style={{ fontSize: "100%", width: "30%" }} scope="col">
                {t("Date Created")}
              </th>
              <th style={{ width: "20%" }} scope="col">
                {t("Name")}
              </th>
              <th style={{}} scope="col">
                {t("Email")}
              </th>
              <th style={{ fontSize: "100%", width: "20%" }} scope="col">
                {t("Organization Name")}
              </th>
              <th
                style={{ textAlign: "center", fontSize: "100%", width: "7%" }}
                scope="col"
              >
                {t("Devices")}
              </th>
              <th scope="col">{t("File URL")}</th>
            </tr>
          </thead>
          <tbody>
            {filteredData
              .sort(
                (a, b) =>
                  new Date(getDate((b?.createdAt))) -
                  new Date(getDate((a?.createdAt)))
              )
              .map((ota) => {
                const users =
                  (ota?.users) && (ota?.users)?.length > 0
                    ? (ota?.users)
                    : [{}]; // Ensure at least one row

                return (
                  <React.Fragment key={ota.otaId}>
                    {users.map((el, index) => (
                      <tr
                        key={`${ota.otaId}-${index}`}
                        style={{ fontSize: "95%", borderBottomWidth: 2 }}
                      >
                        {/* Main OTA Data (Only in the first row for each OTA) */}
                        {index === 0 && (
                          <>
                            <td
                              rowSpan={users.length}
                              style={{
                                fontSize: "100%",
                                color: "#000",
                                overflow: "hidden",
                                width: "20px",
                                verticalAlign: "middle",
                                border: "2px solid #ccc",
                              }}
                            >
                              {ota.versionNo || "N/A"}
                            </td>
                            <td
                              rowSpan={users.length}
                              style={{
                                paddingLeft: "10px",
                                fontSize: "100%",
                                color: "grey",
                                verticalAlign: "middle",
                                border: "2px solid #ccc",
                              }}
                            >
                              {formatTimestamp((ota.createdAt))}
                            </td>
                          </>
                        )}

                        {/* User-specific Data */}
                        <td
                          style={{
                            paddingLeft: "10px",
                            fontSize: "100%",
                            color: "grey",
                            border: "2px solid #ccc",
                          }}
                        >
                          {el?.name || el?.esp_id || "N/A"}
                        </td>
                        <td
                          style={{
                            paddingLeft: "10px",
                            fontSize: "100%",
                            color: "grey",
                            border: "2px solid #ccc",
                          }}
                        >
                          {el?.email || "N/A"}
                        </td>
                        <td
                          style={{
                            paddingLeft: "10px",
                            fontSize: "100%",
                            color: "grey",
                            border: "2px solid #ccc",
                          }}
                        >
                          {el?.orgName || "N/A"}
                        </td>
                        <td
                          style={{
                            paddingLeft: "10px",
                            fontSize: "100%",
                            color: "grey",
                            border: "2px solid #ccc",
                          }}
                        >
                          {el?.devices ? Object.keys(el.devices).length : "N/A"}
                        </td>

                        {/* File URL (Only in the first row for each OTA) */}
                        {index === 0 && (
                          <td
                            rowSpan={users.length}
                            style={{
                              paddingLeft: "10px",
                              color: "grey",
                              cursor: "pointer",
                              verticalAlign: "middle",
                              border: "2px solid #ccc",
                            }}
                          >
                            <a
                              href={ota.fileUrl}
                              className="text-blue-800 font-bold"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {ota.versionNo} URL 🔗
                            </a>
                          </td>
                        )}
                      </tr>
                    ))}
                  </React.Fragment>
                );
              })}
          </tbody>
        </table>
        </div>
      )}
      <style>
        {`
          .spinner {
            border: 4px solid rgba(0, 0, 0, 0.1);
            border-left-color: #E1B84B;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            display:flex
          }
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </>
  );
}

export default Cloud;
